import $ from 'jquery';
import Filter from './Filter';

// ListFilter
export default class ListFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    this.filterType = "ListFilter";
    this.getElement().on('click', "ul li", this.onClick.bind(this));
    this.getElement().on('click', "h3 .reset", this.reset.bind(this));

    this.getElement().find("li.active").each((index, item) => {
      let slug = $(item).data('slug');
      this.toggleValue(slug);
      this.updateReset();
    });
  }

  getValue() {
    let value = this.getElement().find('li.active');
    let returnArray = [];

    value.each(function() {
      returnArray.push($(this).data('slug'));
    });

    return (typeof returnArray[0] === 'undefined') ? false : returnArray;
  }

  setValue(values) {
    this.reset(true);

    if( ! values ) {
      return;
    }

    if( typeof values == "string" ) {
      values = values.split(/\s|\+/);
    }

    for( let i=0; i < values.length; i++ ) {
      let value = values[i];

      let checkbox = this.getElement().find('[data-slug=' + value + '] input[type=checkbox]');
        checkbox.prop('checked', true);

      this.getElement().find('[data-slug=' + value + ']').addClass('active');
    }
  }

  toggleValue(value) {
    let checkbox = this.getElement().find('[data-slug=' + value + '] input[type=checkbox]');
      checkbox.prop('checked', !checkbox.prop('checked') );

    // console.log('checkbox', checkbox.prop('checked'));
    if(checkbox.prop('checked')) {
      this.getElement().find('[data-slug=' + value + ']').addClass('active');
    } else {
      this.getElement().find('[data-slug=' + value + ']').removeClass('active');
    }
  }

  getKey() {
    return this.getElement().find('ul[data-key]').data('key');
  }

  onClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    let slug = $(ev.currentTarget).data('slug');

    this.toggleValue(slug);
    this.updateReset();

    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: this.getValue(),
      sender: this
    });

    return false;
  }

  reset(ev, silent = false) {
    this.getElement().find('input[type=checkbox]').prop('checked', false);
    this.getElement().find('li.active').removeClass('active');
    this.updateReset();

    if (!silent) {
      $.messages.send({
        type: 'FILTER/VALUE_CHANGED',
        key: this.getKey(),
        value: '',
        sender: this
      });
    }
    
  }

  updateReset() {
    if(!this.getValue()) {
      this.getElement().find("h3 .reset").fadeOut();
    } else {
      this.getElement().find("h3 .reset").fadeIn();
    }
  }
}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/ListFilter.js
 **/